import FormatBadge from './FormatBadge';

export { FormatBadge };

export default FormatBadge;
